import { STRINGS } from '@/constants/farmerSolutions'

import YoutubeRed from '../svg/YoutubeRed'

const ESamadhan = () => (
  <a
    href="https://www.youtube.com/c/DeHaat/videos"
    rel="noopener noreferrer"
    target="_blank"
    className="mt-6 py-5 px-6 text-lg leading-[1.11] bg-[#ff0000] rounded-xl inline-flex text-white items-center justify-center shadow-lg shadow-[#ff0000]/10"
  >
    <YoutubeRed />
    <span className="ml-2.5">{STRINGS.E_SAMADHAN}</span>
  </a>
)

export default ESamadhan
